module.exports = __webpack_public_path__ + "static/dash-inicio-216d42bc1c92c02d28c15e8bdd3a049d.png";